var exports = {
  "f": "xae11d333--4ea642--section-title",
};

module.exports = exports;
